import {
	AccountWithWalletsAndPermissions,
	CountResponse,
	createBlockAccountMutation,
} from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type BlockAccountModel = ConfirmModalModel<
	AccountWithWalletsAndPermissions,
	number,
	CountResponse
>;

export const createBlockAccountModel = (): BlockAccountModel => {
	const blockAccountMutation = createBlockAccountMutation();

	const model = createConfirmModalModel({
		modalData: declareModalData<AccountWithWalletsAndPermissions>(),
		mutation: blockAccountMutation,
		mapModalData: ({ id }) => id,
		successMessageKey: 'block-account.success',
	});

	return model;
};
